import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { ButtonModule } from '@hglobal/common';

import { StatusIconComponent } from '../status-icon/status-icon.component';

@Component({
  selector: 'pp-common-confirm-dialog-content',
  imports: [StatusIconComponent, ButtonModule],
  templateUrl: './confirm-dialog-content.component.html',
  styleUrl: './confirm-dialog-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogContentComponent {
  readonly label = input<string>();
  readonly title = input<string>();
  readonly subTitle = input<string>();
  readonly cancelCaption = input<string>();
  readonly okCaption = input<string>();
  readonly iconName = input<string>();
  readonly isOkDisabled = input<boolean>(false);
  readonly status = input<'danger' | 'success' | 'default' | 'warn'>();
  readonly discard = output();
  readonly ok = output();
}
